
import { defineComponent, reactive, toRefs } from 'vue'
import rem from '@/utils/rem.js'
import QrCode from './component/QrCode.vue'
import Info from './component/Info.vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { Dialog } from 'vant'

// 设计稿750=1:1    1rem = 100px
rem(750, 750)
export default defineComponent({
  name: 'ServiceInfo',
  components: {
    QrCode,
    Info
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const state = reactive({
      active: ''
    })

    const userId = localStorage.getItem('userId')
    if (userId) {
      store.commit('setUserId', userId)
    }

    const logout = () => {
      Dialog.confirm({
        title: '提示',
        message: '确定要退出到登录页?',
        confirmButtonColor: '#ff8c00'
      }).then(() => {
        const insuCode = JSON.parse(localStorage.getItem('userInfo')).insuCode
        store.commit('setUserId', '')
        localStorage.removeItem('userId')
        localStorage.removeItem('userInfo')
        router.push({
          path: '/huBeiService/userLogin',
          query: { insuCode: insuCode }
        })
      })
    }

    return {
      ...toRefs(state),
      userId,
      logout
    }
  }
})
